export const siteSettings = {
  name: "100x Trades",
  link: "https://100xtrades.net",
  email: "support@100xtrades.net",
  appLink: "https://app.100xtrades.net",
};
